import useSWR from "swr";
import { LogLevel } from "../../Shared/hooks/useLogging/Logging-types";
import { useLogging } from "../../Shared/hooks/useLogging/useLogging";
import { SWR_KEYS } from "../Utilities/swrKeys";
import { apFetcher } from "../Utilities/axiosPrivateFetcher_SWR";
export const useCustomerOrdersQuery = () => {
    const { datadogLog } = useLogging();
    const { data, error, isLoading, isValidating } = useSWR(SWR_KEYS.CUSTOMER_ORDERS, apFetcher("/MyMeals/GetCustomerOrders"), {
        onSuccess: (data, error) => {
            if (!data.success) {
                const errorMessage = new Error(error);
                datadogLog("GetCustomerOrders fetch error", LogLevel.ERROR, undefined, errorMessage);
            }
        },
        onError: (error) => {
            datadogLog("GetCustomerOrders error", LogLevel.ERROR, undefined, error);
        },
    });
    return {
        data,
        error,
        isLoading,
        isValidating,
    };
};
